Monitoring.Models.SocialContents ||= {}

class Monitoring.Models.SocialContents.ApplestoreContentFactory

  create: (socialContent, allTags) ->
    content = new Monitoring.Models.SocialContents.AnalysisUnitFactory().create(socialContent, allTags)
    return content

  canHandle: (socialContent) ->
    return socialContent.data.type == "apple_app_store"
